<template>
  <app-drawer :model-value="modelValue" :persistent="false" size="sm"
              @update:model-value="$emit('close', 'outside')"
              @cancel="$emit('close', 'cancel')"
  >
    <template #title>{{ title }}</template>

    <template #body>
      <!-- @slot the filters themselves -->
      <slot name="body"></slot>
    </template>

    <!-- Labels and locators are fixed on purpose, so the filters drawers cannot drift apart -->
    <template #footer>
      <app-button
        type="ghost"
        variant="neutral"
        data-locator="clear-button"
        @click="$emit('clear')"
      >
        {{ $t('common.reset') }}
      </app-button>
      <app-button
        data-locator="apply-button"
        @click="$emit('apply')"
      >
        {{ $t('common.applyFilters') }}
      </app-button>
    </template>
  </app-drawer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * Shell shared by every filters pane: an AppDrawer sized and configured the same way, with the
 * shared reset/apply footer. Consumers only bring their title, their locator and their filters.
 *
 * Both ways of asking to close, the header button and an outside interaction (scrim, route
 * change), come back as a single `close` event carrying its source. Most panes treat them
 * alike; the few that do not switch on the source rather than wiring two separate handlers.
 *
 * `data-locator` is not declared as a prop: it falls through to the drawer, which forwards it
 * through useDataLocator like every other consumer.
 *
 * @displayName FiltersDrawer
 */
export default defineComponent({
  name: 'FiltersDrawer',
  props: {
    /**
     * @model
     * Visibility state of the drawer
     */
    modelValue: {
      type: Boolean,
      default: false,
    },
    /**
     * Drawer title, expected to match the label of the button that opens it
     */
    title: {
      type: String,
      required: true,
    },
  },
  emits: ['close', 'clear', 'apply'],
})
</script>
